// eslint-disable-next-line import/no-anonymous-default-export
export default {
  TRANSACTIONS_FETCH_REQUEST: 'transactions/fetchTransactionsRequest',
  TRANSACTIONS_FETCH_SUCCESS: 'transactions/fetchTransactionsSuccess',
  TRANSACTIONS_FETCH_ERROR: 'transactions/fetchTransactionsError',

  TRANSACTIONS_ADD_REQUEST: 'transactions/addTransactionsRequest',
  TRANSACTIONS_ADD_SUCCESS: 'transactions/addTransactionsSuccess',
  TRANSACTIONS_ADD_ERROR: 'transactions/addTransactionsError',

  TRANSACTIONS_DELETE_REQUEST: 'transactions/deleteTransactionsRequest',
  TRANSACTIONS_DELETE_SUCCESS: 'transactions/deleteTransactionsSuccess',
  TRANSACTIONS_DELETE_ERROR: 'transactions/deleteTransactionsError',

  TRANSACTIONS_BY_DATE_ERROR: 'transaction/getTransByDateError',
};
